import { useState } from "react";
import { Sidebar } from "./Sidebar";
import { TokenCounter } from "./TokenCounter";
import { SignUpButton } from "./BookMeeting";
import { Button } from "@/components/ui/button";
import { Menu, Play, Zap } from "lucide-react";

export const DashboardLayout = ({ user, children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  // Check if user is in demo mode
  const isDemo = user?.is_demo === true;

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex">
      <Sidebar user={user} isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      
      <main className="flex-1 min-h-screen overflow-x-hidden">
        {/* Mode Banner */}
        <div className={`w-full py-1.5 px-4 text-center text-sm font-medium flex items-center justify-center gap-2 ${
          isDemo 
            ? "bg-amber-500/20 text-amber-300 border-b border-amber-500/30" 
            : "bg-emerald-500/20 text-emerald-300 border-b border-emerald-500/30"
        }`}>
          {isDemo ? (
            <>
              <Play className="w-3.5 h-3.5 fill-current" />
              Demo Mode
              <span className="text-amber-400/60 text-xs ml-2">— Exploring with sample data</span>
            </>
          ) : (
            <>
              <Zap className="w-3.5 h-3.5" />
              Live Mode
            </>
          )}
        </div>

        {/* Top Bar with Token Counter and Sign Up */}
        <div className="sticky top-0 z-20 glass border-b border-white/5 px-4 py-3 flex items-center justify-between">
          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setSidebarOpen(true)}
              className="text-white"
            >
              <Menu className="w-5 h-5" />
            </Button>
          </div>
          <div className="hidden lg:block" />
          <div className="flex items-center gap-3">
            {user?.email && (
              <span className="text-zinc-300 text-sm">{user.email}</span>
            )}
            {/* Upgrade Plan button */}
            {user?.is_demo && (
              <a href="/pricing-demo">
                <Button size="sm" className="bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white hover:from-violet-700 hover:to-fuchsia-700 text-xs">
                  Upgrade Plan
                </Button>
              </a>
            )}
            {!user?.is_demo && (
              <SignUpButton size="sm" variant="outline" className="hidden sm:flex border-violet-500/30 text-violet-400 hover:bg-violet-500/10" />
            )}
            <TokenCounter isDemo={isDemo} />
          </div>
        </div>
        
        <div className="p-6 md:p-8 lg:p-12 max-w-[1600px]">
          {children}
        </div>

        <footer className="border-t border-white/5 px-6 py-4 text-right">
          <p className="text-zinc-500 text-xs">Copyright (c) 2026 Beruf LLC</p>
        </footer>
      </main>
    </div>
  );
};
